import { Injectable, OnDestroy } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';

import {
  CALENDAR_LABEL,
  CLOSE_CALENDAR_LABEL,
  COMPARISON_DATE_LABEL,
  END_DATE_LABEL,
  NEXT_MONTH_LABEL,
  NEXT_MULTI_YEAR_LABEL,
  NEXT_YEAR_LABEL,
  OPEN_CALENDAR_LABEL,
  PREVIOUS_MONTH_LABEL,
  PREVIOUS_MULTI_YEAR_LABEL,
  PREVIOUS_YEAR_LABEL,
  START_DATE_LABEL,
  SWITCH_TO_MONTH_VIEW_LABEL,
  SWITCH_TO_MULTI_YEAR_VIEW_LABEL,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { LanguageService } from '../language/language.service';

/**
 * a11y: replaces Angular Material's default English `MatDatepickerIntl` with a
 * locale-aware version so the calendar toggle and inner navigation buttons
 * ("Previous month", "Next month", "Choose month and year", etc.) announce
 * Hebrew / English / Arabic names that follow the current `LanguageService`
 * selection. Registered via the {@link MatDatepickerIntl} token in
 * `MaterialModule` so every `<mat-datepicker>` / `<mat-datepicker-toggle>` in
 * the app picks it up automatically.
 */
@Injectable()
export class LocalizedMatDatepickerIntl
  extends MatDatepickerIntl
  implements OnDestroy
{
  private readonly subscription: Subscription;

  constructor(private readonly languageService: LanguageService) {
    super();
    this.subscription = this.languageService.selectedLanguage$.subscribe(
      (language) => {
        if (!language) return;
        const key = language.language as 'hebrew' | 'english' | 'arabic';

        this.calendarLabel = CALENDAR_LABEL[key];
        this.openCalendarLabel = OPEN_CALENDAR_LABEL[key];
        this.closeCalendarLabel = CLOSE_CALENDAR_LABEL[key];
        this.prevMonthLabel = PREVIOUS_MONTH_LABEL[key];
        this.nextMonthLabel = NEXT_MONTH_LABEL[key];
        this.prevYearLabel = PREVIOUS_YEAR_LABEL[key];
        this.nextYearLabel = NEXT_YEAR_LABEL[key];
        this.prevMultiYearLabel = PREVIOUS_MULTI_YEAR_LABEL[key];
        this.nextMultiYearLabel = NEXT_MULTI_YEAR_LABEL[key];
        this.switchToMonthViewLabel = SWITCH_TO_MONTH_VIEW_LABEL[key];
        this.switchToMultiYearViewLabel = SWITCH_TO_MULTI_YEAR_VIEW_LABEL[key];
        this.startDateLabel = START_DATE_LABEL[key];
        this.endDateLabel = END_DATE_LABEL[key];
        this.comparisonDateLabel = COMPARISON_DATE_LABEL[key];

        // Notify all subscribed datepicker instances to re-render their labels.
        this.changes.next();
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
